<div
  class="min-h-screen bg-gray-50 flex flex-col justify-center py-12 px-4 sm:px-6 lg:px-8"
>
  <div class="sm:mx-auto sm:w-full sm:max-w-md">
    <h1 class="text-center text-2xl font-bold tracking-tight text-gray-900">
      Update Your Password
    </h1>
    <p class="mt-2 text-center text-sm text-gray-600">
      A workspace administrator reset the password for
      <span class="font-semibold">{{ userEmail }}</span
      >. Enter the temporary password you received and choose a new one to
      regain access.
    </p>
  </div>

  <div class="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
    <div class="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
      @if (store.error()) {
      <div class="mb-4">
        <lib-error-alert [error]="store.error()" />
      </div>
      } @if (successMessage()) {
      <sb-success-alert [message]="successMessage()" class="mb-4" />
      }

      <form
        class="flex flex-col gap-y-2"
        [formGroup]="form"
        (ngSubmit)="submit()"
      >
        <sb-text-input
          id="currentPassword"
          label="Temporary password"
          type="password"
          autocomplete="current-password"
          formControlName="current_password"
          [required]="true"
          [errorMessage]="
            formSubmitted() &&
            form.controls.current_password.hasError('required')
              ? 'Temporary password is required'
              : null
          "
        ></sb-text-input>

        <sb-text-input
          id="newPassword"
          label="New password"
          type="password"
          autocomplete="new-password"
          formControlName="new_password"
          [required]="true"
          helpText="Must be at least 8 characters and different from the temporary password"
          [errorMessage]="
            formSubmitted()
              ? form.controls.new_password.hasError('required')
                ? 'New password is required'
                : form.controls.new_password.hasError('minlength')
                ? 'New password must be at least 8 characters'
                : newMatchesCurrent()
                ? 'New password cannot match the temporary password'
                : null
              : null
          "
        ></sb-text-input>

        <sb-text-input
          id="confirmPassword"
          label="Confirm new password"
          type="password"
          autocomplete="new-password"
          formControlName="confirm_password"
          [required]="true"
          [errorMessage]="
            formSubmitted()
              ? form.controls.confirm_password.hasError('required')
                ? 'Please confirm your new password'
                : passwordsMismatch()
                ? 'Passwords do not match'
                : null
              : null
          "
        ></sb-text-input>

        <shared-submit-button
          buttonText="Update password"
          loadingText="Updating..."
          [fullWidth]="true"
          [isLoading]="store.isLoading()"
          [disabled]="
            form.invalid || passwordsMismatch() || newMatchesCurrent()
          "
        />
      </form>
    </div>
  </div>
</div>
